import React from "react"
import OmniAural from "omniaural"
import { Themes } from "../managers/ThemeManager"
import BulletList from "./screen-components/BulletList"
import { Header } from "./screen-components/PageHeader"

const LandingPage = ({ history, cookies }) => {
  const images = Themes.currentTheme().images

  const checkFactorAndRedirect = () => {
    const defaultFactor = OmniAural.state?.config?.default_registration_factor?.value()

    let registrationRoute = "/register_pfa"

    if (defaultFactor === "second") {
      registrationRoute = "/register"
    }

    history.push(registrationRoute)
  }

  const createBulletListItems = (strIn) => {
    const arrOut = []
    Object.keys(Themes.currentTheme().strings).forEach((entry) => {
      if (entry.includes(strIn) && Themes.currentTheme().strings[entry].length !== 0) {
        arrOut.push(Themes.currentTheme().strings[entry])
      }
    })
    arrOut.push(
      <span>
        Prior to registering, we recommend that you{" "}
        <a className="text-link" href="/certs">
          download a DoD certificate
        </a>{" "}
        to your device to avoid interuptions.
      </span>
    )
    return arrOut
  }

  return (
    <div className="landing-page-container">
      <Header />
      <img src={images.appHeroImage} className="app-hero-image" alt="app hero" />
      <div className="body-container">
        <div className="body-container-head">
          <h5 className="bold">{Themes.currentTheme().strings.registration_greeting}</h5>
        </div>
        <div className="body-container-body">
          <BulletList items={createBulletListItems("register_instructions")} />
        </div>
      </div>
      <div className="body-container-register">
        <button type="button" onClick={checkFactorAndRedirect} className="register-button">
          <h5>REGISTER</h5>
        </button>
        <div className="register-addl-text">
          <p>Already registered?</p>
          <p className="text-link" onClick={() => history.push("/registered")}>
            Log in to manage your account
          </p>
        </div>
        <div className="register-addl-text">
          <p>Have Questions?</p>
          <a className="text-link" href="/faq">
            Click Here
          </a>
        </div>
      </div>
    </div>
  )
}

export default LandingPage
